<template>
  <section>
    <div class="container">
      <UISectionTitle>
        {{ t("gt_slider_section.most_trending_group_tours") }}
      </UISectionTitle>
      <Swiper
        class="p-[20px_!important]"
        :modules="[SwiperAutoplay, SwiperPagination, SwiperNavigation]"
        :breakpoints="{
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        }"
        :loop="true"
        :prevent-clicks="false"
        :pagination="{
          clickable: true,
        }"
        :navigation="true"
        :a11y="{
          enabled: true,
          prevSlideMessage: t('gt_slider_section.previous_slide'),
          nextSlideMessage: t('gt_slider_section.next_slide'),
        }"
        :autoplay="{
          delay: 4000,
          disableOnInteraction: true,
        }"
        :speed="500"
      >
        <SwiperSlide v-for="tour in tours" :key="tour.id">
          <UITourCard :tour="tour" />
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { TripFilters } from "~/types/filter";

const props = defineProps<{
  filters?: TripFilters;
}>();

const { t } = useI18n();
const BaseUrl = inject("BaseUrl") as string;
const tours = ref<Trip[]>([]);

function buildQueryParams() {
  const params = new URLSearchParams();
  params.append("filter[is_trending]", "1");
  
  if (props.filters) {
    if (props.filters.minPrice != null) {
      params.append("min_price", props.filters.minPrice.toString());
    }
    if (props.filters.maxPrice != null) {
      params.append("max_price", props.filters.maxPrice.toString());
    }
    if (props.filters.minDays != null) {
      params.append("min_days", props.filters.minDays.toString());
    }
    if (props.filters.maxDays != null) {
      params.append("max_days", props.filters.maxDays.toString());
    }
    if (props.filters.continentIds && props.filters.continentIds.length > 0) {
      props.filters.continentIds.forEach((id, index) => {
        params.append(`continent_ids[${index}]`, id.toString());
      });
    }
    if (props.filters.monthIds && props.filters.monthIds.length > 0) {
      props.filters.monthIds.forEach((id, index) => {
        params.append(`month_ids[${index}]`, id.toString());
      });
    }
  }
  
  return params.toString();
}


async function fetchTours() {
  const queryString = buildQueryParams();
  const { data } = await useAuthFetch<Api>(
    `${BaseUrl}/trips?${queryString}`
  );
  const allTrips = (data.value?.data.trips as Trip[]) || [];
  tours.value = allTrips;
}

// Watch for filter changes
watch(
  () => props.filters,
  () => {
    fetchTours();
  },
  { deep: true, immediate: true }
);

// Initial fetch
await fetchTours();
</script>
